module.exports = __webpack_public_path__ + "static/media/ico_cover.b495d653.svg";